import styled from 'styled-components';

import { Typography } from 'src/typography';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SectionLabel = styled(Typography.Label)`
  color: var(--dcm-wallet-section-label-color, ${({ theme }) => theme.colors.grey[45]});
  letter-spacing: 1px;
  white-space: nowrap;
`;

export const SectionRule = styled.span`
  background: var(--dcm-wallet-section-rule-color, ${({ theme }) => theme.colors.grey[90]});
  flex-grow: 1;
  height: 1px;
`;
